import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'
import breakpoint from 'styled-components-breakpoint'
import { createUrl } from '../../utils/url-utils'

const Title = styled.h3`
  font-size: 20px;
  margin-bottom: 4px;
  line-height: 1.25;
  margin-top: 0;

  ${breakpoint('tablet')`
    font-size: 17px;
  `}
`

const Blurb = styled.p`
  font-size: 15px;
  margin-bottom: 8px;
  line-height: 1.4;
  margin-top: 8px;
  color: #72747b;
`

const Small = styled.small`
  color: #abb1b9;
  margin: 0;
  font-size: 11px;
  font-family: 'GT Pressura Mono', monospace;
`

const StyledLink = styled(Link)`
  display: block;
  text-decoration: none;
`

const ArticlePreview = ({ article }) => {
  const {
    slug,
    title,
    featureImage,
    updatedAt,
    legacy,
    legacyTitle,
    category,
    createdAt,
    childContentfulBlogPostIntroTextNode: {
      childMarkdownRemark: { excerpt },
    },
  } = article

  return (
    <StyledLink
      to={createUrl(legacy, legacyTitle, category, title, createdAt, slug)}
    >
      <div>
        {featureImage && (
          <Box mb={4}>
            <Img alt="" fluid={featureImage.fluid} />
          </Box>
        )}
        <Title>{title}</Title>
        <Small style={{ margin: 0 }}>Last updated {updatedAt}</Small>
        <Blurb
          dangerouslySetInnerHTML={{
            __html: excerpt,
          }}
        />
      </div>
    </StyledLink>
  )
}

ArticlePreview.propTypes = {
  article: PropTypes.shape({
    slug: PropTypes.string,
    title: PropTypes.string,
    featureImage: PropTypes.object,
    updatedAt: PropTypes.string,
    childContentfulBlogPostIntroTextNode: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        excerpt: PropTypes.string,
      }),
    }),
  }),
}

export default ArticlePreview
